import React from "react";
import PropTypes from 'prop-types'
import { BgButton } from "../../pages/Theme";

const ButtonSquare = ({onClick, height, ...props}) => {
    return(
        <BgButton 
            className={`flex flex-row h-${height} w-${height} border-2 py-3 items-center 
                            justify-center rounded-xl filter drop-shadow-sm cursor-pointer`}
            onClick={onClick}
        >
           { props.children }
        </BgButton>
    )
}

ButtonSquare.propTypes = {
    image: PropTypes.string,
    onClick: PropTypes.func,
    height: PropTypes.string,
    
}

export default ButtonSquare